import { render, staticRenderFns } from "./AIChatWidgetAbHeroPicker.vue?vue&type=template&id=28b4b4f2&scoped=true"
import script from "./AIChatWidgetAbHeroPicker.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetAbHeroPicker.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetAbHeroPicker.vue?vue&type=style&index=0&id=28b4b4f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b4b4f2",
  null
  
)

export default component.exports